import React from 'react';
import appUserRoutes from "../../../../appUserRoutes";
import {TAB_PRIMARY} from "../MainView";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import TypeDetails from "../../../../components/TecRmi/Vehicle/TypeDetails";
import {useTecRmi} from "../../../../contexts/TecRmiContext";

const PrimaryTab = props => {
  const { ident, showType } = useTecRmi()

  return <React.Fragment>
    <BreadcrumbsItem to={appUserRoutes.tecRmi.tab(ident, TAB_PRIMARY)}>Podstawowe</BreadcrumbsItem>
    <TypeDetails />
  </React.Fragment>;
};

PrimaryTab.propTypes = {

};

export default PrimaryTab;